import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productos',
  templateUrl: '../../pages/productos/productos.component.html',
  styleUrls: ['../../pages/productos/productos.component.css']
})
export class ProductosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
